import { canv } from "@/canv/global.js";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import type { DocumentViewerWidget } from "@/elements/documentViewer/DocumentViewer";
import type { DocumentPreviewPageOption, widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmDocumentPreviewPage extends wmBase {
    constructor(options: widgetOption<DocumentPreviewPageOption>[]) {
        super();
        this.currentPage = options[0].value.currentPageNumber;
        this.previewPage = options[0].value.previewPageNumber;
    }

    build() {
        return `
            <div class="wm_documentPreviewPage">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.3 14.5V19M4 14.5H16.6V12.916C16.5998 12.5811 16.5062 12.2529 16.3297 11.9683C16.1533 11.6837 15.9009 11.454 15.601 11.305L13.999 10.495C13.6991 10.346 13.4467 10.1163 13.2703 9.83166C13.0938 9.54706 13.0002 9.21888 13 8.884V4.6H13.9C14.3774 4.6 14.8352 4.41036 15.1728 4.07279C15.5104 3.73523 15.7 3.27739 15.7 2.8C15.7 2.32261 15.5104 1.86477 15.1728 1.52721C14.8352 1.18964 14.3774 1 13.9 1H6.7C6.22261 1 5.76477 1.18964 5.42721 1.52721C5.08964 1.86477 4.9 2.32261 4.9 2.8C4.9 3.27739 5.08964 3.73523 5.42721 4.07279C5.76477 4.41036 6.22261 4.6 6.7 4.6H7.6V8.884C7.59982 9.21888 7.50623 9.54706 7.32975 9.83166C7.15327 10.1163 6.90089 10.346 6.601 10.495L4.999 11.305C4.69911 11.454 4.44673 11.6837 4.27025 11.9683C4.09377 12.2529 4.00018 12.5811 4 12.916V14.5Z" 
                        stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `;
    }

    init() {
        this.rootEl = document.querySelector(".wm_documentPreviewPage");
        this.rootEl?.removeEventListener("click", this.toggleSubMenu, false);
        this.rootEl?.addEventListener("click", this.toggleSubMenu, false);
    }

    toggleSubMenu = () => {
        if (this.submenuEl) {
            this.closeSubMenu();
        } else {
            this.openSubMenu();
        }
    };

    openSubMenu() {
        if (!this.rootEl) return;

        document.querySelector(".widgetSubMenu")?.remove();

        canv.widgetMenu.subMenuBoss = "wm_documentPreviewPage";

        const submenu = document.createElement("div");
        submenu.className = "widgetSubMenu wm_documentPreviewPage_submenu";
        submenu.style.opacity = "0";
        document.body.prepend(submenu);

        submenu.innerHTML += this.submenuTemplate("setPreviewPage", this.previewPage);
        submenu.innerHTML += this.submenuTemplate("goToPreviewPage", this.previewPage);

        this.bindSubMenuEvents(submenu);

        this.submenuEl = submenu;
        this.rootEl.classList.add("active");

        setTimeout(canv.widgetMenu.TryLocateMenu.bind(canv.widgetMenu), 50);
    }

    closeSubMenu() {
        this.submenuEl?.remove();
        this.submenuEl = null;
        this.rootEl?.classList.remove("active");
    }

    bindSubMenuEvents(submenu: HTMLElement) {
        const items = submenu.querySelectorAll<HTMLElement>(".wm_documentPreviewPage_submenu_item");
        items.forEach((el) => {
            el.addEventListener("click", this.itemClick, { once: true });
        });
    }

    submenuTemplate(type: "setPreviewPage" | "goToPreviewPage", num: number) {
        const text =
            type === "setPreviewPage" ? "Закрепить эту страницу" : "Перейти к закрепленной";
        return `
            <div class="wm_documentPreviewPage_submenu_item ${type}" data-action="${type}">
                <p class="subMenuText">${text}</p>
                <div class="subMenuCount">${num}</div>   
            </div>
        `;
    }

    itemClick = (e: MouseEvent): void => {
        const target = e.currentTarget as HTMLElement;
        const actionType = target.dataset.action as
            | "setPreviewPage"
            | "goToPreviewPage"
            | undefined;

        if (!actionType) return;

        const selectedEntities = canv.canvasController.selected;
        const isDocumentViewer = (obj: ExtendsOfElementBase): obj is DocumentViewerWidget =>
            obj?.constructorName === "documentViewer";

        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;

            if (child && isDocumentViewer(child)) {
                if (actionType === "setPreviewPage") {
                    this.setPreviewPage(child);
                } else if (actionType === "goToPreviewPage") {
                    this.goToPreviewPage(child);
                }
            }
        }

        this.closeSubMenu();
    };

    setPreviewPage(child: DocumentViewerWidget) {
        this.previewPage = this.currentPage;
        child.setPreviewPage(this.currentPage);
    }

    goToPreviewPage(child: DocumentViewerWidget) {
        this.currentPage = this.previewPage;
        child.goToPage(this.previewPage);
    }

    rootEl: HTMLElement | null = null;
    submenuEl: HTMLElement | null = null;
    currentPage = 0;
    previewPage = 0;
}
